import { render, staticRenderFns } from "./DevPc.vue?vue&type=template&id=4b569e7c&scoped=true"
import script from "./DevPc.vue?vue&type=script&lang=js"
export * from "./DevPc.vue?vue&type=script&lang=js"
import style0 from "./DevPc.vue?vue&type=style&index=0&id=4b569e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b569e7c",
  null
  
)

export default component.exports